"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _filter = _interopRequireDefault(require("../utils/filter.utils"));
function $filter(_ref) {
  var filtersState = _ref.filtersState,
    filtersParams = _ref.filtersParams;
  return {
    getFilterQuery: function getFilterQuery(filterKey) {
      return _filter.default.extractQuery(filterKey, filtersParams[filterKey]);
    },
    shouldFilterReset: function shouldFilterReset(filterKey) {
      return _filter.default.checkReset(filterKey, filtersState[filterKey]);
    },
    shouldSubFilterReset: function shouldSubFilterReset(filterKey, filterPayload) {
      return _filter.default.checkFilterReset({
        filterKey: filterKey,
        filterState: filtersState[filterKey],
        filterPayload: filterPayload
      });
    },
    isFilterItemSelected: function isFilterItemSelected(filterKey, filterPayload) {
      return _filter.default.checkSelected({
        filterKey: filterKey,
        filterState: filtersState[filterKey],
        filterPayload: filterPayload
      });
    },
    isAllFilterItemsSelected: function isAllFilterItemsSelected(filterKey, filterCode) {
      return _filter.default.checkAllSelected({
        filterKey: filterKey,
        filterState: filtersState[filterKey],
        filterCode: filterCode
      });
    }
  };
}
var _default = exports.default = $filter;